<template>
  <page :back-to="getPreviousUrl" :title="pageTitle" size="is-desktop mb-16">
    <div slot="page-header-right">
      <confirm-dialog
        v-if="magazine"
        @confirmed="destroy"
        title="Deleting magazine?"
        message="Warning the deleted data wouldn't restore."
        confirm-text="Delete magazine"
        type="is-danger"
      >
        <button slot="trigger" class="button is-danger is-outlined mr-2">Delete</button>
      </confirm-dialog>

      <button
        v-if="form"
        class="button is-primary"
        :class="{'is-loading': form.processing}"
        @click="save"
      >Save Changes
      </button>
    </div>

    <form v-if="form" @submit.prevent="save">
      <div class="columns">
        <div class="column is-4">

          <div class="box">
            <div class="columns">
              <div class="column is-full">
                <strong>Magazine Logo</strong>
              </div>
            </div>

            <div class="columns is-clearfix">
              <div class="column is-6">
                <upload-file
                  ref="uploadFile"
                  :endpoint="$store.getters.kytebaseMediaUploadUrl"
                  :additional="{ collection: 'images' }"
                  @uploaded="onLogoUploaded"
                  auto-reset
                >
                  <template slot-scope="{progress}">
                    <div
                      v-if="progress && ! progress.isComplete()"
                    >Uploading {{ progress.percent() }}%
                    </div>

                    <image-picker
                      v-else
                      @picked="file => $refs.uploadFile.upload(file)"
                      croppable
                      :croppie="{ viewMode: 1 }"
                    >
                      <a slot="trigger" @click="is_logo=true">Upload Logo</a>
                    </image-picker>
                  </template>
                </upload-file>
                <div class="has-text-centered pt-5">
                  <img v-if="logo_url" :src="logo_url" style="width: 150px;"/>
                </div>
              </div>


              <div class="column is-6">
                <upload-file
                  ref="uploadFile"
                  :endpoint="$store.getters.kytebaseMediaUploadUrl"
                  :additional="{ collection: 'images' }"
                  @uploaded="onLogoUploaded"
                  auto-reset
                >
                  <template slot-scope="{progress}">
                    <div
                      v-if="progress && ! progress.isComplete()"
                    >Uploading {{ progress.percent() }}%
                    </div>

                    <image-picker
                      v-else
                      @picked="file1 => $refs.uploadFile.upload(file1)"
                      croppable
                      :croppie="{ viewMode: 1, output: 'image/png'}"
                    >
                      <a slot="trigger" class="is-pulled-right" @click="is_logo=false">Upload tp logo</a>
                    </image-picker>
                  </template>
                </upload-file>
                <div class="has-text-centered pt-5 is-pulled-right">
                  <img v-if="tp_logo_url" :src="tp_logo_url" style="width: 150px;"/>
                </div>
              </div>


            </div>

          </div>

          <div class="box">
            <b-field label="Publisher">
              <publisher-select
                :current="magazine ? magazine.publisher : null"
                v-model="form.publisher_id"
              ></publisher-select>
            </b-field>

            <b-field label="Primary Category">
              <magazine-category-select v-model="form.category_id"></magazine-category-select>
            </b-field>

            <b-field label="Secondary Category">
              <magazine-category-select v-model="form.second_category_id"></magazine-category-select>
            </b-field>

            <hr/>

            <b-field>
              <b-checkbox v-model="form.is_gold">Is XTRA?</b-checkbox>
            </b-field>
          </div>

          <div class="box">
            <b-field label="Country">
              <country-select v-model="form.country_id" expanded></country-select>
            </b-field>

            <b-field label="Language">
              <language-select v-model="form.language_id" expanded></language-select>
            </b-field>
          </div>
        </div>

        <div class="column">
          <div class="box">
            <b-field label="Magazine name">
              <b-input v-model="form.name" placeholder="Magazine name"></b-input>
            </b-field>

            <b-field label="Magazine description">
              <b-input
                v-model="form.description"
                type="textarea"
                rows="5"
                placeholder="Magazine description"
              ></b-input>
            </b-field>

            <b-field label="Keywords" message="This keywords will be used for search.">
              <b-taginput v-model="keywords" placeholder="Keywords"></b-taginput>
            </b-field>
          </div>

          <div class="box">
            <h1 class="title is-5">Price Per Issue</h1>

            <div class="columns">
              <div class="column is-4">
                <b-field label="Price (USD)">
                  <b-input v-model.number="form.issue_price" placeholder="e.g. 3.99"></b-input>
                </b-field>
              </div>

              <div class="column is-4">
                <b-field label="Product Id">
                  <b-input v-model="form.issue_product_id"></b-input>
                </b-field>
              </div>

              <div class="column is-4">
                <b-field label="Income Share %">
                  <b-input v-model="form.income_sharing_percentage"></b-input>
                </b-field>
              </div>
            </div>
          </div>

          <div class="box" style="position: relative">
            <div class="level is-mobile">
              <div class="level-left">
                <h1 class="title is-5">Subscription Plans</h1>
              </div>

              <div class="level-right">
                <b-dropdown position="is-bottom-left">
                  <button type="button" class="button is-white" slot="trigger">
                    <span>Add Plan</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item
                    v-for="type in magazineSubscriptionPlanTypes"
                    :key="type.id"
                    @click="addPlan(type)"
                    :disabled="magazineHasSubscriptionPlanOnType(type)"
                  >
                    <strong>{{ type.frequency }}</strong>
                    <div>{{ type.issue_activation_type }}</div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>

            <div v-for="(plan, index) in form.plans" :key="index">
              <h1 class="mb-2">
                <strong>{{ plan.type.frequency }}</strong>
                subscription
                plan ({{ plan.type.issue_activation_type }})
              </h1>

              <div class="columns">
                <div class="column">
                  <b-field class="mt-6">
                    <b-checkbox v-model="plan.available_for_in_app_purchases">For in-app purchases?</b-checkbox>
                  </b-field>
                </div>
                <div class="column">
                  <b-field class="mt-6">
                    <b-checkbox v-model="plan.available_for_web_purchases">For web purchases?</b-checkbox>
                  </b-field>
                </div>
              </div>

              <div class="columns" style="align-items: flex-end">
                <div class="column is-4">
                  <b-field :label="`Number of issues`">
                    <b-input type="number" v-model="plan.issues_count"></b-input>
                  </b-field>
                </div>

                <div class="column is-4">
                  <b-field label="Price (USD)">
                    <b-input v-model.number="plan.price" placeholder="e.g. 3.99"></b-input>
                  </b-field>
                </div>

                <div class="column is-4">
                  <b-field label="Product Id">
                    <b-input v-model="plan.product_id"></b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns" style="align-items: flex-end">
                <div class="column is-4">
                  <b-field label="Title">
                    <b-input v-model="plan.title"></b-input>
                  </b-field>
                </div>
                <div class="column is-7">
                  <b-field label="Description">
                    <b-input v-model="plan.description"></b-input>
                  </b-field>
                </div>

                <div class="column is-1">
                  <confirm-dialog
                    title="Warning!"
                    message="Deleting subscription plan?"
                    @confirmed="removePlan(plan)"
                  >
                    <button type="button" class="button" slot="trigger">
                      <b-icon icon="close"></b-icon>
                    </button>
                  </confirm-dialog>
                </div>
              </div>

              <div v-if="plan.available_for_in_app_purchases" class="message is-warning is-light">
                <div class="message-body">
                  Please make sure the subscription plan replicated in the
                  <a
                    href="https://appstoreconnect.apple.com/WebObjects/iTunesConnect.woa/ra/ng/app/1502084160/addons"
                    target="_blank"
                  >Apple in-app purchase</a> admin panel.
                </div>
              </div>

              <hr v-if="form.plans.length - 1 != index"/>
            </div>

            <section v-if="form.plans.length == 0" class="section">
              <div class="content has-text-grey has-text-centered">
                <p>{{ $tc('Nothinghere') }}</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <hr/>

      <div class="is-pulled-right">
        <router-link class="button mr-2" to="/magazine/magazines">Cancel</router-link>

        <button
          v-if="form"
          class="button is-primary"
          :class="{'is-loading': form.processing}"
        >Save Changes
        </button>
      </div>
    </form>
  </page>
</template>

<script>
import ImagePicker from "@/components/ImagePicker";
import UploadFile from "@/components/UploadFile";

export default {
  components: {
    ImagePicker,
    UploadFile
  },
  data() {
    return {
      is_logo: false,
      logo_url: null,
      tp_logo_url: null,
      subscriptionPlanTypes: new window.RemoteCollection(
        "/admin/api/magazine/subscription-plan-types"
      ),
      magazine: null,
      form: null
    };
  },

  created() {
    this.subscriptionPlanTypes.load();

    if (this.$route.params.id) {
      this.$http
        .get(`/admin/api/magazine/magazines/${this.$route.params.id}`)
        .then(res => {
          this.form = this.newForm();
          this.magazine = res.data.data;
          this.logo_url = this.magazine ? this.magazine.logo_url : null;
          this.tp_logo_url = this.magazine ? this.magazine.tp_logo_url : null;
        });
    } else {
      this.form = this.newForm();
    }
  },

  watch: {
    magazine(magazine) {
      for (let field in magazine) {
        this.form[field] = magazine[field];
      }
    }
  },

  computed: {
    pageTitle() {
      return this.$route.params.id
        ? `Edit Magazine - #${this.$route.params.id}`
        : "Create Magazine";
    },

    keywords: {
      get() {
        return this.form && this.form.keywords && this.form.keywords.length > 0
          ? this.form.keywords.split(",")
          : [];
      },

      set(value) {
        this.form.keywords = value.join(",");
      }
    },

    magazineSubscriptionPlanTypes() {
      return this.subscriptionPlanTypes.data.filter(type => type.id != 1);
    }
  },

  methods: {
    newForm() {
      return new window.Form({
        publisher_id: null,
        category_id: null,
        second_category_id: null,
        is_gold: false,
        country_id: null,
        language_id: null,
        name: null,
        description: null,
        income_sharing_percentage: "0/0",
        keywords: null,
        issue_product_id: null,
        issue_price: 0,
        logo_path: null,
        tp_logo_path: null,
        plans: []
      });
    },

    magazineHasSubscriptionPlanOnType(type) {
      return this.form.plans.filter(plan => plan.type_id == type.id).length > 0;
    },

    addPlan(type) {
      if (!this.magazineHasSubscriptionPlanOnType(type)) {
        this.form.plans.push({
          type,
          type_id: type.id,
          issues_count: 0,
          price: 0,
          product_id: null,
          available_for_in_app_purchases: false,
          available_for_web_purchases: false
        });
      }
    },

    removePlan(plan) {
      let index = this.form.plans.indexOf(plan);

      this.form.plans.splice(index, 1);
    },

    getSubscriptionPlanTypeById(typeId) {
      return this.subscriptionPlanTypes.data.find(t => (t.id = typeId));
    },

    save() {
      return this.magazine ? this.update(this.magazine) : this.create();
    },

    create() {
      this.form.post("/admin/api/magazine/magazines").then(this.whenCreated);
    },

    whenCreated() {
      this.$buefy.toast.open("Magazine created");

      this.$router.push("/magazine/magazines");
    },

    update(magazine) {
      this.form
        .put(`/admin/api/magazine/magazines/${magazine.id}`)
        .then(this.whenUpdated);
    },

    whenUpdated() {
      this.$buefy.toast.open("Magazine updated");

      this.$router.push("/magazine/magazines");
    },

    onLogoUploaded({data: image}) {
      if (this.is_logo) {
        this.form.logo_path = image.path;
        this.logo_url = image.url;
      } else {
        this.form.tp_logo_path = image.path;
        this.tp_logo_url = image.url;
      }
    },

    destroy() {
      new window.Form()
        .delete(`/admin/api/magazine/magazines/${this.magazine.id}`)
        .then(this.whenDestroyed);
    },

    whenDestroyed() {
      this.$buefy.toast.open("Magazine deleted");

      this.$router.push("/magazine/magazines");
    }
  }
};
</script>
